import DealsFilter from './DealsFilter.component';

export default DealsFilter;
